export type Insurance = {
  id: string;
  title: string;
  cardNumber: string;
  isActive: string;
  userId: string;
};

export const dummyInsuranceData: Insurance[] = [];
